import styled from 'styled-components';
import ShareWhatsAppSvg from '../../../assets/onboarding/newHome/share-whatsapp.svg';

const ShareWhatsAppIcon = styled(ShareWhatsAppSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.2rem'};
height: ${props => props.height || '4.2rem'};
display: flex;
`;

export default ShareWhatsAppIcon;
